import React, { ChangeEvent } from 'react';
import { Modal } from 'react-bootstrap';
import { MdClose, MdSave } from 'react-icons/md';
import { InputText } from '~/components/NovosInputs';
import { Row, Col } from 'react-bootstrap';
import { CustomButtonNovo } from '~/components/Buttons/CustomButtonNovo';
import { useClassificacaoIbsCbs } from '../../hooks/useClassificacaoIbsCbs';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { IbsCbsServices } from '../../services/index';
import { toast } from 'react-toastify';

const MySwal = withReactContent(Swal);

export const ModalCST: React.FC = () => {
  const {
    formClassificao: { setValue },
    formModalCST: {
      register,
      control,
      errors,
      handleSubmit,
      reset,
      watch,
      setValue: setValueModalCST,
    },
    handleOpenModal,
    openModal,
    setNewCST,
  } = useClassificacaoIbsCbs();
  const { createCST } = IbsCbsServices;

  const handleSaveModal = handleSubmit(async (data: any) => {
    const textInputs = (
      <>
        <span>{watch('des_cst_ibs_cbs')}</span>
        <br />
        <span>{watch('cst_ibs_cbs')}</span>
      </>
    );

    const { isConfirmed } = await MySwal.fire({
      title: 'Confirma a inserção de nova CST:',
      html: textInputs,
      showCancelButton: true,
      showCloseButton: false,
      showConfirmButton: true,
      confirmButtonColor: '#0065FF',
      cancelButtonColor: '#DE350B',
      showDenyButton: false,
      confirmButtonText: 'SIM',
      cancelButtonText: 'NÃO',
      customClass: { popup: 'swal-wide' },
    });
    if (!isConfirmed) return;

    try {
      const { cod_cst_ibs_cbs, success, message } = await createCST(data);
      if (success) {
        setNewCST(true);
        setValue('cod_cst_ibs_cbs', {
          value: cod_cst_ibs_cbs,
          label: `${data.cst_ibs_cbs} - ${data.des_cst_ibs_cbs}`,
        });
        handlecancelModal();
        return toast.success(message);
      }
      toast.warn(message);
    } catch (error: any) {
      toast.warn(error.message);
    }
  });

  const handlecancelModal = () => {
    reset();
    handleOpenModal(false);
  };

  return (
    <Modal
      show={openModal}
      centered
      onHide={() => {
        handleOpenModal(false);
      }}
      size="xl"
    >
      <Modal.Header>
        <Modal.Title>Nova CST-IBS/CBS</Modal.Title>
        <button
          type="button"
          onClick={() => handleOpenModal(false)}
          style={{
            right: '10px',
            top: '10px',
            fontSize: '20px',
            cursor: 'pointer',
            outline: 'none',
            background: 'none',
            border: 'none',
          }}
        >
          x
        </button>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col sm={12} md={5}>
            <InputText
              label="Descrição *"
              name="des_cst_ibs_cbs"
              placeholder="Descrição CST"
              caseInput="upper"
              control={control}
              register={register}
              maxLength={50}
              isError={!!errors.des_cst_ibs_cbs}
            />
          </Col>
          <Col sm={12} md={3}>
            <InputText
              name="cst_ibs_cbs"
              label="CST CBS/IBS *"
              placeholder="0"
              maxLength={3}
              minLength={3}
              max={999}
              alignRight
              min={0}
              register={register}
              control={control}
              isError={!!errors.cst_ibs_cbs}
              onInput={(e: ChangeEvent<HTMLInputElement>) => {
                const numbersOnly = e.target.value.replace(/\D/g, '');
                setValueModalCST('cst_ibs_cbs', numbersOnly);
              }}
            />
          </Col>
          <Col
            xs="auto"
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              gap: '10px',
              marginTop: '30px',
            }}
          >
            <CustomButtonNovo
              onClick={handleSaveModal}
              width="170px"
              type="submit"
              label="Gravar"
              icon={MdSave}
              disabled={false}
              style={{ backgroundColor: '#009e0f' }}
            />
            <CustomButtonNovo
              onClick={handlecancelModal}
              width="170px"
              label="Cancelar"
              icon={MdClose}
              disabled={false}
              style={{ backgroundColor: '#bf9000' }}
            />
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
};
